import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import VerifyInviteNewUser from './components/verify_invite/VerifyInviteNewUser'
import VerifyInviteExistingUser from './components/verify_invite/VerifyInviteExistingUser'

const VerifyInvite: React.FC = () => {
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token') ?? ''
  const type = searchParams.get('type') ?? ''

  const navigate = useNavigate()

  useEffect(() => {
    if (token === '' || type === '') {
      navigate('/home')
    }
  }, [token, type])

  if (type === 'existing_user') {
    return (
      <VerifyInviteExistingUser />
    )
  }

  return (
    <VerifyInviteNewUser />
  )
}

export default VerifyInvite
